import React, { Suspense, lazy } from 'react';
import { HeroSection } from '../components/HeroSection';
import { SocialProofPopup } from '../components/ui/SocialProofPopup';
import { BackgroundAudio } from '../components/ui/BackgroundAudio';
import { useMetaPixel } from '../hooks/useMetaPixel';
const PainPointSection = lazy(() => import('../components/PainPointSection').then(m => ({
  default: m.PainPointSection
})));
const ProductRevealSection = lazy(() => import('../components/ProductRevealSection').then(m => ({
  default: m.ProductRevealSection
})));
const BonusSection = lazy(() => import('../components/BonusSection').then(m => ({
  default: m.BonusSection
})));
const TestimonialsSection = lazy(() => import('../components/TestimonialsSection').then(m => ({
  default: m.TestimonialsSection
})));
const CTASection = lazy(() => import('../components/CTASection').then(m => ({
  default: m.CTASection
})));
const GuaranteeSection = lazy(() => import('../components/GuaranteeSection').then(m => ({
  default: m.GuaranteeSection
})));
const FAQSection = lazy(() => import('../components/FAQSection').then(m => ({
  default: m.FAQSection
})));
const ClosingSection = lazy(() => import('../components/ClosingSection').then(m => ({
  default: m.ClosingSection
})));
export function SalesPage() {
  useMetaPixel();
  return <main className="min-h-screen bg-navy overflow-x-hidden" data-id="element-364">
      <BackgroundAudio data-id="element-365" />
      <SocialProofPopup data-id="element-366" />
      <HeroSection data-id="element-367" />
      <Suspense fallback={<div className="min-h-[200px]" data-id="element-369" />} data-id="element-368">
        <PainPointSection data-id="element-370" />
        <ProductRevealSection data-id="element-371" />
        <BonusSection data-id="element-372" />
        <TestimonialsSection data-id="element-373" />
        <CTASection data-id="element-374" />
        <GuaranteeSection data-id="element-375" />
        <FAQSection data-id="element-376" />
        <ClosingSection data-id="element-377" />
      </Suspense>
    </main>;
}